export const EditIconV2 = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2837_34827)">
        <path
          d="M2.96255 16.2053H3.91298L13.4821 6.63614L12.5317 5.6857L2.96255 15.2548V16.2053ZM16.2254 5.7073L13.4605 2.94241L14.3677 2.03518C14.6125 1.79037 14.9149 1.66797 15.275 1.66797C15.635 1.66797 15.9374 1.79037 16.1822 2.03518L17.1326 2.98561C17.3774 3.23042 17.4998 3.53283 17.4998 3.89284C17.4998 4.25286 17.3774 4.55527 17.1326 4.80007L16.2254 5.7073ZM15.3182 6.61453L4.4314 17.5013H1.6665V14.7364L12.5533 3.84964L15.3182 6.61453ZM13.0069 6.16092L12.5317 5.6857L13.4821 6.63614L13.0069 6.16092Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2837_34827">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
